// src/components/renderers/TypeInRenderer.js
import React from 'react';

const TypeInRenderer = ({ 
  question, 
  userAnswer = [], 
  onAnswerChange, 
  showFeedback,
  showCorrectAnswers 
}) => {
  const content = question.content || {};
  const answers = content.answers || [];
  const questionText = content.text || '';

  const handleInputChange = (index, value) => {
    if (!showFeedback && onAnswerChange) {
      const newAnswer = [...userAnswer];
      newAnswer[index] = value;
      onAnswerChange(newAnswer);
    }
  };

  const renderQuestionWithBlanks = () => {
    const parts = questionText.split(/\[(.*?)\]/);
    let blankIndex = 0;
    
    return parts.map((part, index) => {
      if (index % 2 === 0) {
        return <span key={index} dangerouslySetInnerHTML={{ __html: part }} />;
      } else {
        const currentBlankIndex = blankIndex++;
        return (
          <span key={index} className="blank-placeholder">
            <span className="blank-number">({currentBlankIndex + 1})</span>
          </span>
        );
      }
    });
  };

  const checkAnswer = (index) => {
    const answer = answers[index];
    const userInput = userAnswer[index] || '';
    const correctAnswers = [
      answer.text,
      ...(answer.alternatives ? answer.alternatives.split(',').map(a => a.trim()) : [])
    ];
    return correctAnswers.some(correct => 
      correct.toLowerCase() === userInput.toLowerCase()
    );
  };

  return (
    <div className="question-renderer type-in-renderer">
      <div className="question-text-display">
        {renderQuestionWithBlanks()}
      </div>

      <div className="blanks-section">
        <h4>Fill in the blanks:</h4>
        {answers.map((answer, index) => {
          const isCorrect = showFeedback || showCorrectAnswers ? checkAnswer(index) : null;
          
          return (
            <div key={index} className="blank-input-group">
              <label className="blank-label">Blank {index + 1}:</label>
              <input
                type="text"
                className={`blank-input ${
                  (showFeedback || showCorrectAnswers) 
                    ? (isCorrect ? 'correct' : 'incorrect') 
                    : ''
                }`}
                value={userAnswer[index] || ''}
                onChange={(e) => handleInputChange(index, e.target.value)}
                disabled={showFeedback}
                placeholder="Type your answer"
              />
              {(showFeedback || showCorrectAnswers) && !isCorrect && (
                <div className="correct-answer-display">
                  Correct: {answer.text}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {showFeedback && content.generalFeedback && (
        <div className="feedback-section">
          <div className="general-feedback">
            <strong>Feedback:</strong> {content.generalFeedback}
          </div>
        </div>
      )}
    </div>
  );
};

export default TypeInRenderer;